import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/CapP.png";

export const capitolPunishmentDetail = {
  "capitol-punishment": {
    id: "capitol-punishment",
    title: "Capitol Punishment",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "capitol-punishment",
        items: [
          {
            id: "capitol-punishment-1",
            title: "Capitol Punishment",
            description: "Washington, D.C. 2011",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
